var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3872_3593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8403 3.31938H3.18674C2.60678 3.31938 2.05057 3.54977 1.64048 3.95986C1.23039 4.36996 1 4.92616 1 5.50612V20.8133C1 21.3932 1.23039 21.9494 1.64048 22.3595C2.05057 22.7696 2.60678 23 3.18674 23H18.4939C19.0738 23 19.63 22.7696 20.0401 22.3595C20.4502 21.9494 20.6806 21.3932 20.6806 20.8133V13.1597M19.0406 1.67933C19.4755 1.24436 20.0655 1 20.6806 1C21.2958 1 21.8857 1.24436 22.3207 1.67933C22.7556 2.1143 23 2.70424 23 3.31938C23 3.93452 22.7556 4.52447 22.3207 4.95943L11.9337 15.3464L7.56021 16.4398L8.65357 12.0663L19.0406 1.67933Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_3593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconEdit);
export default __webpack_public_path__ + "static/media/button-icon-edit.314cf3b0e6664a88d064b94c30401828.svg";
export { ForwardRef as ReactComponent };